/**
 * @generated SignedSource<<69df2a99fea7401b97e95732bdae9f3b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type listItemsAllCompaniesQuery$variables = {
  companyIds?: ReadonlyArray<string> | null;
};
export type listItemsAllCompaniesQuery$data = {
  readonly allCompanies: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly companyName: string;
        readonly entryId: number | null;
        readonly generalInfo: {
          readonly descriptionDe: string | null;
          readonly descriptionEn: string | null;
        } | null;
        readonly id: string;
        readonly logo: string | null;
      } | null;
    } | null>;
  } | null;
};
export type listItemsAllCompaniesQuery = {
  response: listItemsAllCompaniesQuery$data;
  variables: listItemsAllCompaniesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "companyIds"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "companyIds",
    "variableName": "companyIds"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logo",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "descriptionEn",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "descriptionDe",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entryId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "listItemsAllCompaniesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CompanyNodeConnection",
        "kind": "LinkedField",
        "name": "allCompanies",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CompanyNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CompanyNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GeneralInfoNode",
                    "kind": "LinkedField",
                    "name": "generalInfo",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "listItemsAllCompaniesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CompanyNodeConnection",
        "kind": "LinkedField",
        "name": "allCompanies",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CompanyNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CompanyNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GeneralInfoNode",
                    "kind": "LinkedField",
                    "name": "generalInfo",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a23841b4492cfa4f2c6913a282e86d30",
    "id": null,
    "metadata": {},
    "name": "listItemsAllCompaniesQuery",
    "operationKind": "query",
    "text": "query listItemsAllCompaniesQuery(\n  $companyIds: [String!]\n) {\n  allCompanies(companyIds: $companyIds) {\n    edges {\n      node {\n        id\n        logo\n        companyName\n        generalInfo {\n          descriptionEn\n          descriptionDe\n          id\n        }\n        entryId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c461ee7168d3daa6584deaf9ae94b685";

export default node;
